<template>
  <div class="col-md-6 pb-3">
    <div class="card h-100 pl-3 pr-3">
      <div class="d-inline pt-1 my-auto d-flex justify-content-around">
        <div class="d-inline-block text-center" v-if="isStoreReady && showAddReading">
          <a class="pointer" role="button" @click="showPanel">
            <img src="@/assets/img/add_meter_reading.png" alt="Add a meter reading icon" />
            <span class="d-inline-block px-2">Add Reading</span>
          </a>
        </div>
        <div class="d-inline-block text-center">
          <a href="#" data-toggle="modal" data-target=".cot">
            <img src="@/assets/img/cot.png" alt="Change of tenancy icon" />
            <span class="d-inline-block pl-2 mr-2">Transfer</span>
          </a>
        </div>
        <div class="d-inline-block text-center">
          <a href="#" data-toggle="modal" data-target="#RecordManualPayment">
            <img src="@/assets/img/manual_payment.png" alt="Manual payment icon" />
            <span class="d-inline-block px-2">Manual Payment</span>
          </a>
        </div>
        <div class="d-inline-block text-center" v-if="account.AllocationMethod == 'Manual' && manualAllocationsEnabled">
          <a class="pointer" role="button" @click="navigateToManualAllocations">
            <img src="@/assets/img/sliders-solid.png" alt="Manual allocation icon" />
            <span class="d-inline-block px-2">Manual Allocation</span>
          </a>
        </div>
        <div class="d-inline-block text-center">
          <a href="#" data-toggle="modal" data-target="#createBillRun">
            <img src="@/assets/img/new_bill.png" alt="New bill icon" />
            <span class="d-inline-block px-2">New Bill</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReadingsPanel from "@/components/panels/readings-panel-components/ReadingsPanel";
import {mapState} from "vuex";

export default {
  methods: {
    showPanel() {
      this.$showPanel({
        component: ReadingsPanel,
        openOn: "right",
        cssClass: "add-meter-reading-panel",
        props: {
          //any data you want passed to your component
        }
      });
    },
    navigateToManualAllocations() {
      var customerRef = this.$route.params.customerRef
      this.$router.push({ name: 'manualAllocationsDashboard', params: { customerId: customerRef } })
    }
  },
  computed: {
    ...mapState({
      activeService: state => state.meters.activeService
    }),
    // Prevents the 'add reading' button from being displayed until the store is ready.
    isStoreReady() {
      return this.activeService !== undefined;
    },
    // Show 'add reading' button if customer can add readings for NHH periods
    showAddReading() {
      // Show if readings tab is shown (not currently HH OR has historic readings)
      // This covers: NHH-only customers, and CoMC customers who had NHH periods
      return this.$store.getters.showReadingsTab;
    },
    account() {
      return this.$store.state.customers.account;
    },
    manualAllocationsEnabled() {
      return this.$config.honeycomb.manualAllocations;
    },
  }
};
</script>
